import { ColumnDef } from '@tanstack/react-table'
import { GetInviteFriendCommissionHistoryResponseData } from '@/modules/promotion/type'
import { format } from 'date-fns'

export const COMMISSION_TYPE_LABELS: Record<string, string> = {
	TURNOVER: 'ยอดเทิร์น',
	SIGNUP: 'สมัครสมาชิก',
	FIRST_DEPOSIT: 'ฝากครั้งแรก',
	DEPOSIT: 'ฝาก',
	RETURN_LOSS: 'คืนยอดเสีย',
}

export const COMMISSION_TYPE_OPTIONS: Array<{
	value: string
	label: string
}> = [
	{ value: 'TURNOVER', label: 'ยอดเทิร์น' },
	{ value: 'FIRST_DEPOSIT', label: 'ฝากครั้งแรก' },
	{ value: 'DEPOSIT', label: 'ฝาก' },
	{ value: 'SIGNUP', label: 'สมัครสมาชิก' },
	{ value: 'RETURN_LOSS', label: 'คืนยอดเสีย' },
]

export const columns: ColumnDef<GetInviteFriendCommissionHistoryResponseData>[] =
	[
		{
			accessorKey: 'playerPhone',
			header: 'ผู้ชวน/ผู้ถูกชวน',
			cell: ({ row }) => (
				<div className="space-y-1">
					<p>ผู้ชวน: {row.original.playerPhone || '-'}</p>
					<p className="text-xs text-muted-foreground">
						ผู้ถูกชวน: {row.original.referredPlayerPhone || '-'}
					</p>
					<p className="text-xs text-muted-foreground">
						ประเภท:{' '}
						{COMMISSION_TYPE_LABELS[row.original.commissionType] ||
							row.original.commissionType}
					</p>
					<p className="text-xs text-muted-foreground">
						ชั้น: {row.original.tier}
					</p>
				</div>
			),
		},
		{
			accessorKey: 'turnoverAmount',
			header: 'ยอดเทิร์น/ยอดเสีย',
			cell: ({ row }) => (
				<div className="space-y-1 text-left text-sm">
					<p>ยอดเทิร์น: {row.original.turnoverAmount.toLocaleString()}</p>
					<p className="text-muted-foreground">
						ยอดเสีย: {row.original.lossAmount.toLocaleString()}
					</p>
				</div>
			),
		},
		{
			accessorKey: 'commissionAmount',
			header: 'คอมมิชชั่น',
			cell: ({ row }) => (
				<div className="space-y-1 text-left text-sm">
					<p className="font-medium">
						จำนวน: {row.original.commissionAmount.toLocaleString()}
					</p>
					<p className="text-xs text-muted-foreground">
						เรทคอม: {(row.original.commissionRate * 100).toFixed(2)}%
					</p>
				</div>
			),
		},
		{
			accessorKey: 'balanceBefore',
			header: 'ยอดก่อน/หลัง',
			cell: ({ row }) => (
				<div className="space-y-1 text-left text-sm">
					<p>ก่อน: {row.original.balanceBefore.toLocaleString()}</p>
					<p className="text-muted-foreground">
						หลัง: {row.original.balanceAfter.toLocaleString()}
					</p>
				</div>
			),
		},
		{
			accessorKey: 'cumulatedAt',
			header: 'เวลา',
			cell: ({ row }) => (
				<div className="space-y-1 text-xs">
					<p>
						คำนวณ:{' '}
						{row.original.cumulatedAt
							? format(new Date(row.original.cumulatedAt), 'dd/MM/yyyy HH:mm')
							: '-'}
					</p>
					<p className="text-muted-foreground">
						สร้าง:{' '}
						{format(new Date(row.original.createdAt), 'dd/MM/yyyy HH:mm')}
					</p>
				</div>
			),
		},
	]
